import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const sections = {
  privacy: {
    title: "Privacy Policy",
    intro: "NxT (CareerXAI) helps you understand and build your career. That requires personal data, so here is exactly what we do with it.",
    items: [
      ["What we collect", "Your name, email, the answers you give in the Career DNA assessment, your profile details (education, role, city, salary range), your missions, quests, Career Proof work, resume text you choose to analyse, interview answers and coach conversations."],
      ["How we use it", "To compute your Career DNA, matches, readiness and personalised missions; to power AI features (coach, roadmap, simulator, resume and interview analysis); to send notifications you opt into; and to run aggregate, anonymised product analytics."],
      ["AI processing", "Text you submit to AI features is sent to our AI provider to generate a response. We never sell your data, and we do not use your data to train models."],
      ["Payments", "Payments are processed by Razorpay. We never see or store your card, UPI or bank details — only the payment status and plan."],
      ["Sharing", "Your Career Wrapped is only visible to people you share the link with. Referral pages show first name, archetype and matches — nothing else."],
      ["Retention & deletion", "You can delete your account from Profile → Delete account. This permanently removes your profile, Career DNA, progress, proofs, conversations and analyses."],
      ["Security", "Passwords are hashed with bcrypt, sessions use signed tokens, API keys live only on the server, and sensitive endpoints are rate-limited."],
      ["Contact", "Questions about your data? Email privacy@nxt.careers."],
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "By using NxT you agree to these terms. We keep them short and human.",
    items: [
      ["What NxT is", "A career discovery and skill-building system. Career matches, readiness scores, salary figures and AI outputs are estimates and guidance — never guarantees of employment, income or outcomes."],
      ["Your account", "Keep your login secure. You must be 16 or older. One account per person."],
      ["NxT Plus", "Plus is a subscription billed via Razorpay at the price shown at checkout (monthly or annual). You can cancel anytime; access continues until the end of the paid period. Fees already paid are non-refundable except where required by law."],
      ["Your content", "Work you create (Career Proof, resumes, answers) stays yours. You grant us permission to process it to provide the service."],
      ["Acceptable use", "Don't abuse the AI features, scrape the service, or attempt to access other users' data."],
      ["Changes", "We may update features and these terms. Material changes will be announced in the app."],
      ["Contact", "support@nxt.careers"],
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const s = sections[kind];
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-2xl px-5 py-10" data-testid={`legal-${kind}`}>
        <Link to="/"><Logo /></Link>
        <h1 className="mt-8 font-display text-4xl font-extrabold tracking-tight">{s.title}</h1>
        <p className="mt-3 text-muted-foreground">{s.intro}</p>
        <p className="mt-1 text-xs text-muted-foreground">Last updated: June 2026</p>
        <div className="mt-8 space-y-6">
          {s.items.map(([h, body]) => (
            <section key={h}><h2 className="font-display text-lg font-bold">{h}</h2><p className="mt-1 text-sm leading-relaxed text-muted-foreground">{body}</p></section>
          ))}
        </div>
        <div className="mt-10 flex gap-4 text-sm font-semibold text-indigo-600">
          <Link to="/privacy" data-testid="link-privacy">Privacy</Link><Link to="/terms" data-testid="link-terms">Terms</Link><Link to="/">Home</Link>
        </div>
      </div>
    </div>
  );
}
